<template>
    <div class="com">
        <div id="userInfoArea">
            <div id="userInfo">欢迎 <span id="ic_userName">{{ user.userName }} </span><span>{{ userRole() }}</span>登录本系统</div>
        </div>

        <div id="headArea">问卷大调查</div>

        <!-- 动态背景 -->
        <ul class="background">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>

        <div>
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"
                 preserveAspectRatio="none">
                <path
                    d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
                    opacity=".25" class="shape-fill"></path>
                <path
                    d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
                    opacity=".5" class="shape-fill"></path>
                <path
                    d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
                    class="shape-fill"></path>
            </svg>
        </div>

        <!-- 问卷列表 start -->
        <div v-if="flag.mainFlag" id="listArea">
            <el-select v-model="queryForm.semesterCode" placeholder="学年学期名称" style="width:300px;" filterable @change="queryList">
                <el-option v-for="item in comboData.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>

            <el-col :span="24">
                <div id="emptyInfo" v-if="queInfo.length == 0" class="grid-content bg-purple-dark">
                    没有可查看的评教信息
                </div>
            </el-col>

            <div id="listContainer">
                <div class="listContent" v-for="(item,index) in queInfo" :key="index" @click="openQue(item)">
                    <el-row>
                        <el-col :span="5">
                            <img class="examIcon" src="../../../image/wjdc/icon-wj.png">
                        </el-col>
                        <el-col :span="14" style="margin-top:20px;">
                            <p class="buttonFont">问卷调查名称：&nbsp;{{ item.title }}</p>
                            <p class="buttonFont">问卷开放时间：&nbsp;{{ item.beginDate }}&nbsp;-&nbsp;{{ item.endDate }}</p>
                        </el-col>
                        <el-col :span="5">
                            <div class="examState">
                                <div v-if="item.state === '0'" class="stateBlock" style="background-color: rgb(133,133,133);">未开始</div>
                                <div v-else-if="item.state === '1'" class="stateBlock" style="background-color: rgb(243,0,0);">进行中</div>
                                <div v-else-if="item.state === '2'" class="stateBlock" style="background-color: rgb(51,198,11);">已完成</div>
                                <div v-else class="stateBlock" style="background-color: rgb(133,133,133);">已结束</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 问卷列表 end -->

        <!-- 问卷详情 start -->
        <div v-if="flag.infoFlag || flag.statisticsFlag" id="infoArea">
            <div id="titleContainer">
                <div id="questionnaireTitle">
                    {{ title }}
                </div>
            </div>

            <div id="infoContainer">
                <div v-if="flag.infoFlag" class="grid-content bg-purple-dark" style="width:1100px; margin:0 auto;">
                    <info ref="info" :infoData="infoData" :userCode="user.userCode" :doFlag="doFlag" :state="quesState"/>
                </div>

                <div v-if="flag.statisticsFlag" class="grid-content bg-purple-dark" style="width:1100px; margin:0 auto;">
                    <statistics ref="statistics" :statisticsData="statisticsData" :userCode="user.userCode" :id="id"/>
                </div>
            </div>
        </div>

        <div id="backButton">
            <el-button type="primary" v-show="flag.mainFlag !==true" @click="back" plain>
                <i class="el-icon-s-home"></i>&nbsp;返回
            </el-button>
            <el-button @click="submit" type="warning" plain v-show="flag.infoFlag && subFlag">
                <i class="el-icon-s-promotion"></i>&nbsp;提交
            </el-button>
            <el-button @click="exportFile" type="success" plain v-show="flag.statisticsFlag ===true">
                <i class="el-icon-download"></i>&nbsp;导出
            </el-button>
            <el-button @click="clear" type="danger" plain v-show="flag.infoFlag && clearFlag">
                <i class="el-icon-refresh"></i>&nbsp;重置
            </el-button>
        </div>
        <!-- 问卷详情 end -->
    </div>
</template>

<script>
import {confirmMsg, showNotify} from "utils/message";
import {globalConfig} from "static/config"
import info from "./questionnaireSurvey/info"
import statistics from "./questionnaireSurvey/statistics"

export default {
    components: {
        info,
        statistics
    },
    data() {
        return {
            flag: {
                mainFlag: true,
                infoFlag: false,
                statisticsFlag: false
            },
            //登录人信息
            user: {
                userCode: "",
                userName: "",
                userRoles: "",
            },
            comboData: {
                semester: []
            },
            queInfo: [],
            queryForm: {
                semesterCode: '',
                userCode: '',
                role: ''
            },
            infoData: [],
            statisticsData: [],
            title: '',
            quesState: '',
            doFlag:false,
            id:'',
            clearFlag:false,
            subFlag:false
        }
    },
    mounted() {
        this.userInfo()
    },
    methods: {
        //角色信息
        userInfo() {
            this.$api.system.basic.userInfo({}).then((res) => {
                // res.data.data.phone = '20215060010104'
                this.user.userName = res.data.data.name;
                this.user.userCode = res.data.data.phone;
                this.queryForm.userCode = res.data.data.phone;
                this.user.userRoles = Object.keys(res.data.data.roles).toString();
                this.initData()
            }).catch((err) => {
                console.log(err);
            });
        },
        userRole() {
            if (this.user.userRoles === globalConfig.auth.xs) {
                this.queryForm.role = 'stu'
                return "同学";
            } else {
                this.queryForm.role = 'tea'
                return "老师";
            }
        },
        initData() {
            this.$api.evaluateManage.questionnaireSurvey.initData({}).then((res) => {
                this.comboData.semester = res.data.data.semester
                this.queryForm.semesterCode = res.data.data.semNow
                this.queryList()
            }).catch((err) => {
                console.log(err);
            });
        },
        queryList() {
            this.$api.evaluateManage.questionnaireSurvey.queryList({
                data: this.queryForm
            }).then((res) => {
                this.queInfo = res.data.data
            }).catch((err) => {
                console.log(err);
            });
        },
        exportFile() {
            this.$refs.statistics.exportFile();
        },
        submit() {
            this.$refs.info.submit();
        },
        clear(){
            this.$refs.info.clear();
        },
        //打开问卷
        openQue(rowData) {
            this.title = rowData.title
            this.id = rowData.id
            if (this.queryForm.role === 'tea') {
                this.title += '统计'
            }
            //判断学生打开调查问卷，老师打开调查问卷统计
            let form = {
                'id': rowData.id,
                'userCode': this.queryForm.userCode,
                'type': rowData.type
            }
            this.flag.mainFlag = false;
            if (this.queryForm.role === 'stu') {
                this.quesState = rowData.state
                this.loadInfo(form)
            }
            if (this.queryForm.role === 'tea') {
                this.loadStatistics(form)
            }
        },
        loadStatistics(form) {
            this.showLoadingMask("问卷信息加载中,请稍候...");

            this.$api.evaluateManage.questionnaireSurvey.loadStatistics({
                data: form
            }).then((res) => {
                this.statisticsData = res.data.data
                this.flag.statisticsFlag = true;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        loadInfo(form) {
            this.showLoadingMask("问卷信息加载中,请稍候...");

            this.$api.evaluateManage.questionnaireSurvey.loadInfo({
                data: form
            }).then((res) => {
                this.infoData = res.data.data

               if(parseInt(this.infoData.answerTime) < parseInt(this.infoData.quesAnswerTime)){
                    if(this.infoData.answerTime === '0'){
                        this.doFlag = '0'
                    }else{
                        this.doFlag = '1'
                    }

                    if(this.quesState === '1' || this.quesState === '2'){
                        this.clearFlag = true;
                        this.subFlag = true
                    }
                }else {
                    this.doFlag = '2'
                }

                this.flag.infoFlag = true;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        back() {
            this.flag.mainFlag = true;
            this.flag.infoFlag = false;
            this.flag.statisticsFlag = false;
            this.clearFlag = false
            this.subFlag = false
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
    },
}
</script>

<style>
.com {
    height: calc(100vh);
    margin: 0;
    padding: 0;
    background-color: #D0E6FE;
    overflow: hidden;
}

#userInfoArea {
    position: absolute;
    top: 5px;
    right: 0;
    z-index: 10;
}

#userInfo {
    height: 25px;
    line-height: 25px;
    float: right;
    color: #ffffff;
    margin-right: 20px;
}

#ic_userName {
    font-weight: bold;
    color: #F5AA37;
}

#headArea {
    width: 100%;
    height: 80px;
    background-color: #1EA0FE;
    font-size: 55px;
    letter-spacing: 12px;
    color: #FFFFFF;
    text-shadow: 3px 3px 5px #9DD4FD;
    text-align: center;
    padding-top: 20px;
}

/* ------------------------------动画背景------------------------------ */
@keyframes animate {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 0.7;
        border-radius: 0;
    }

    100% {
        transform: translateY(-1000px) rotate(720deg);
        opacity: 0;
        border-radius: 50%;
    }
}

.background {
    position: absolute;
    width: 100%;
    height: 150px;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    background: rgba(31, 162, 255, 0);
    overflow: hidden;
    z-index: 0;
}

.background li {
    position: absolute;
    display: block;
    list-style: none;
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
    animation: animate 10s linear infinite;
    -webkit-animation: animate 18s linear infinite;
}

.background li:nth-child(0) {
    left: 80%;
    width: 50px;
    height: 50px;
    bottom: -50px;
    animation-delay: 2s;
}

.background li:nth-child(1) {
    left: 45%;
    width: 105px;
    height: 105px;
    bottom: -105px;
    animation-delay: 4s;
}

.background li:nth-child(2) {
    left: 60%;
    width: 120px;
    height: 120px;
    bottom: -120px;
    animation-delay: 5s;
}

.background li:nth-child(3) {
    left: 85%;
    width: 77px;
    height: 77px;
    bottom: -77px;
    animation-delay: 7s;
}

.background li:nth-child(4) {
    left: 20%;
    width: 102px;
    height: 102px;
    bottom: -102px;
    animation-delay: 8s;
}

.background li:nth-child(5) {
    left: 55%;
    width: 65px;
    height: 65px;
    bottom: -65px;
    animation-delay: 10s;
}

.background li:nth-child(6) {
    left: 89%;
    width: 70px;
    height: 70px;
    bottom: -70px;
    animation-delay: 11s;
}

svg {
    /* position: relative; */
    /* display: block; */
    width: calc(370% + 1.3px);
    height: 90px;
}

.shape-fill {
    fill: rgb(31 161 255);
}

#listArea {
    height: calc(100% - 180px);
    text-align: center;
    overflow: hidden;
}

#listContainer {
    height: 100%;
    margin-top: 20px;
    padding-bottom: 50px;
    overflow-y: auto;
}

.listContent {
    width: 1000px;
    margin-top: 25px;
    background-color: #FFFFFF;
    border: 2px solid #FFFFFF;
    border-radius: 5px;
    margin: 0 auto 30px auto;
    cursor: pointer;
}

.listContent:hover {
    border: 2px solid #1EA0FE;
}

#emptyInfo {
    width: 1000px;
    height: 120px;
    line-height: 120px;
    font-size: 18px;
    font-weight: bold;
    color: #DCDFE6;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    margin: 20px auto 20px auto;
}

.examIcon {
    width: 100px;
    height: 100px;
    background-size: 100%;
    margin: 10px 0 0 50px;
    float: left;
}

.examState {
    width: 150px;
    height: 100%;
    float: right;
    margin: 45px 0 0 50px;

}

.stateBlock {
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    color: #FFFFFF;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 3px;
    text-align: center;
}

#backButton {
    position: absolute;
    top: 92%;
    left: 80%;
    z-index: 200;
}

.buttonFont {
    font-size: 15px;
    text-align: left;
}

#titleContainer {
    width: 100%;
    margin: 0 0 20px 0;
    text-align: center;
}

#questionnaireTitle {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    letter-spacing: 5px;
    background-color: orange;
    border-radius: 30px;
    text-align:center;
    padding: 0 50px;
    display: inline-block;
}

#infoArea {
    height: calc(100% - 180px);
    text-align: center;
    overflow: hidden;
}

#infoContainer {
    height: calc(100% - 50px);
    margin-top: 20px;
    padding-bottom: 50px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// questionnaireSurvey.vue?aa53dc9e